import { render, staticRenderFns } from "./side-file-item.vue?vue&type=template&id=6f50824b&scoped=true&"
import script from "./side-file-item.vue?vue&type=script&lang=js&"
export * from "./side-file-item.vue?vue&type=script&lang=js&"
import style0 from "./side-file-item.vue?vue&type=style&index=0&id=6f50824b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f50824b",
  null
  
)

export default component.exports